module.exports = __webpack_public_path__ + "img/moneybag.47cb0b6e.png";